// @flow

import './index.scss';
import * as React from 'react';
import { useTranslate } from '@insolus/react-i18n';
import Button from 'components/Button';
import Icon from 'components/Icon';
import __p from 'utils/__p';

const SellButton = (): React.Node => {
    const { __ } = useTranslate();

    return (
        <Button
            className="SellButton"
            to={__p('/publish')}
            type="primary"
        >
            <Icon type="plus" />
            <span className="SellButton__part SellButton__part--first">
                {__('sell')}
            </span>
            <span className="SellButton__part SellButton__part--second">
                {__('my-machine')}
            </span>
        </Button>
    );
};

export default SellButton;
